import React from "react";
import { Modal, Button } from "react-bootstrap";
import Style from "./ConfirmModal.module.scss";
import Assets from "../../../Layout/Assets";
function FileformatModal({
  showModal,
  setShowModal,
  message
}) {
  return (
    <div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        style={{ zIndex: 20000 }}
        className={Style.DeleteConfirmmodal}
        backdrop="static"
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <div>
           
            <p className={Style.DeleteText}>
              {message}
            </p>
            <div className={Style.BottomSection}>
              <Button
                variant="primary"
                className={Style.cancelBtn}
                onClick={() => setShowModal(false)}
              >
                OK
              </Button>
              
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={() => setShowModal(false)}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
}

export default FileformatModal;
